<div class="company-theme-graph">
  <div #exportTarget class="chart-card">
    <div class="card-header-row">
      <div class="metric-chips">
        <button type="button"
          *ngFor="let m of metricButtons"
          class="metric-chip"
          [class.active]="selectedMetric === m.key"
          [disabled]="isLoading"
          (click)="setMetric(m.key)">
          <span class="chip-dot"
            *ngIf="selectedMetric === m.key"
            [style.background]="m.color"></span>
          {{ m.label }}
        </button>
      </div>
      <div class="chart-toolbar" data-html2canvas-ignore="true">
        <button type="button" class="tool-btn" (click)="resetZoom()" title="Reset zoom" [disabled]="!showChart || isLoading">
          <i class="bi bi-arrow-counterclockwise"></i>
        </button>
        <button type="button" class="tool-btn" (click)="downloadPng()" title="Download PNG" [disabled]="!showChart || isLoading">
          <i class="bi bi-download"></i>
        </button>
      </div>
    </div>

    <p class="zoom-hint" data-html2canvas-ignore="true" *ngIf="showChart">Drag to zoom • Shift + drag to pan  • Double-click to reset</p>

    <div class="chart-container">
      <canvas baseChart *ngIf="showChart"
        [type]="'bar'"
        [data]="chartjsData"
        [options]="chartjsOptions"
        [plugins]="chartPlugins"
        (dblclick)="resetZoom()">
      </canvas>

      <div class="chart-placeholder" *ngIf="!showChart && showDataMissing && !isLoading">
        <i class="bi bi-search empty-state-icon"></i>
        <h5>No data for this metric</h5>
        <p>Try selecting another metric above.</p>
      </div>

      <div class="chart-placeholder" *ngIf="!showChart && loadingFailed && !isLoading">
        <i class="bi bi-exclamation-triangle empty-state-icon"></i>
        <h5>Couldn't load this metric</h5>
        <p>
          Please try again or contact
          <a href="mailto:info@quant-ip.com">info&#64;quant-ip.com</a>.
        </p>
      </div>

      <div class="chart-loading-overlay" *ngIf="isLoading" data-html2canvas-ignore="true">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

    <p class="metric-footnote" *ngIf="showChart && currentYearLabel">
      {{ currentYearLabel }} {{ currentMetricFootnote }}
    </p>
  </div>
</div>
